module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', [_c('a', {
    attrs: {
      "id": "page_25"
    }
  }), _c('a', {
    attrs: {
      "id": "pg25lev1"
    }
  }), _c('img', {
    attrs: {
      "alt": "Morcilla, egg, and crisps",
      "src": "images/f0025-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "recipe_hdnote"
  }, [_vm._v("Okay, so it sounds a little out there, but this tasty tapa is not as crazy as you might think. Unlike the British relationship with crisps (potato chips), which might involve a stop by the corner shop for a sneaky bag of Walker’s, there’s a long-standing tradition of handmade, freshly fried crisps in Spain. I ate this dish in a tapas bar in Barcelona; I loved the idea that you can pimp up a bag of potato chips, so I have re-created it here.")]), _vm._v(" "), _c('div', {
    staticClass: "wrap"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_24"
    }
  }), _c('img', {
    staticClass: "vertical",
    attrs: {
      "alt": "image",
      "src": "images/f0024-01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "yield"
  }, [_vm._v("Serves 4")]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "yield"
  }, [_vm._v("Preparation time: 2 minutes")]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common1.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "yield"
  }, [_vm._v("Cooking time: 10 minutes")]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common2.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "ingred_sublist"
  }, [_vm._v("one 2-oz bag salted potato chips")]), _vm._v(" "), _c('p', {
    staticClass: "ingred_sublist"
  }, [_vm._v("5 oz morcilla (blood sausage), casing removed")]), _vm._v(" "), _c('p', {
    staticClass: "ingred_sublist"
  }, [_vm._v("1 tbsp olive or canola oil")]), _vm._v(" "), _c('p', {
    staticClass: "ingred_sublist"
  }, [_vm._v("3 eggs")]), _vm._v(" "), _c('p', {
    staticClass: "method_txt"
  }, [_vm._v("Empty the bag of chips into a serving dish.")]), _vm._v(" "), _c('p', {
    staticClass: "method_txt"
  }, [_vm._v("Roughly crumble or chop the morcilla. Heat a large nonstick frying pan over high heat and dry-fry the morcilla for 3 to 4 minutes, until cooked through. Scatter the sausage over the chips.")]), _vm._v(" "), _c('p', {
    staticClass: "method_txt"
  }, [_vm._v("Add the oil to the frying pan, heat, and crack the eggs in one by one. Cook for 2 to 3 minutes, until the whites are set but the yolks are still runny (put a lid or plate over the pan to speed it up).")]), _vm._v(" "), _c('p', {
    staticClass: "method_txt"
  }, [_vm._v("Using a spatula, gently place the fried eggs over the morcilla and serve.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7f4097c5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/12-chapter06.vue
// module id = 90
// module chunks = 0